<template>
    <v-modal-slot id="show-statuses-modal"
                  @closed="closeModal">
        <template v-slot:modal-title>
            Información del estado
        </template>

        <template v-slot:modal-content>
            <div class="row">
                <div class="col-6">
                    <strong>Nombre:</strong><br/> <span>{{ status.display_name }}</span>
                </div>

                <div class="col-6">
                    <strong>Fecha:</strong><br/> <span>{{ status.date }}</span>
                </div>
            </div>

            <div class="row">
                <div class="col-6" v.if="!!status.extra_data">
                    <strong>Observaciones:</strong><br/> <span>{{ status.extra_data }}</span>
                </div>
            </div>
        </template>
    </v-modal-slot>
</template>

<script>
import VModal from "../../general/VModal";
import VModalSlot from "../../general/VModalSlot";

export default {
    name: "StatusesListShowModal",
    components: {VModalSlot, VModal},
    props: ['status'],
    data() {
        return {
            statusApp: 'loading',
        }
    },
    mounted() {
        this.statusApp = 'loaded';
    },
    methods: {
        closeModal() {
            this.$emit('closed');
        }
    }
}
</script>
